export default function getProductImage( imageFriendlyPath ) {
    let imagePath;
    try {
        imagePath = require(`../assets/images/productPhotos/${imageFriendlyPath}/1.jpeg`);
    } catch {
        imagePath = require(`../assets/images/default.png`);
    }
    return imagePath;
}
